<script setup>
import { computed } from 'vue'

const props = defineProps({
  label: { type: String, default: '' },
  title: { type: String, default: '' },
  value: { type: [String, Number], default: 0 },
  icon: { type: String, default: '' },
  color: { type: String, default: 'teal' },
  subtitle: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  trend: { type: Number, default: undefined }
})

const colorMap = {
  teal:   { bg: 'bg-teal-100',   text: 'text-teal-600'   },
  navy:   { bg: 'bg-blue-100',   text: 'text-blue-700'   },
  green:  { bg: 'bg-green-100',  text: 'text-green-600'  },
  blue:   { bg: 'bg-blue-100',   text: 'text-blue-600'   },
  purple: { bg: 'bg-purple-100', text: 'text-purple-600' },
  orange: { bg: 'bg-orange-100', text: 'text-orange-600' },
  red:    { bg: 'bg-red-100',    text: 'text-red-600'    },
  yellow: { bg: 'bg-yellow-100', text: 'text-yellow-600' },
}

const iconBg   = computed(() => (colorMap[props.color] || colorMap.teal).bg)
const iconColor = computed(() => (colorMap[props.color] || colorMap.teal).text)
</script>

<template>
  <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
    <div v-if="loading" class="animate-pulse space-y-3">
      <div class="h-4 bg-gray-200 rounded w-1/2"></div>
      <div class="h-8 bg-gray-200 rounded w-1/3"></div>
      <div class="h-3 bg-gray-200 rounded w-1/4"></div>
    </div>

    <template v-else>
      <div class="flex items-center justify-between">
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium text-gray-600 truncate">{{ label || title }}</p>
          <p class="text-3xl font-bold text-gray-900 mt-2">{{ value }}</p>
          <div v-if="trend !== undefined" class="flex items-center mt-2">
            <span v-if="trend >= 0" class="text-sm font-medium text-green-600">
              <i class="pi pi-arrow-up text-xs mr-1"></i>{{ Math.abs(trend) }}%
            </span>
            <span v-else class="text-sm font-medium text-red-500">
              <i class="pi pi-arrow-down text-xs mr-1"></i>{{ Math.abs(trend) }}%
            </span>
          </div>
          <p v-if="subtitle" class="text-sm font-medium text-gray-500 mt-2">
            <i v-if="icon" :class="'pi ' + icon + ' text-xs mr-1'"></i>
            {{ subtitle }}
          </p>
        </div>
        <div v-if="icon" :class="['w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ml-4', iconBg]">
          <i :class="['pi ' + icon + ' text-xl', iconColor]"></i>
        </div>
      </div>
    </template>
  </div>
</template>
